import { render, staticRenderFns } from "./error-boundary.vue?vue&type=template&id=398202ce&scoped=true&"
import script from "./error-boundary.vue?vue&type=script&lang=js&"
export * from "./error-boundary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "398202ce",
  null
  
)

export default component.exports